<template>
  <div class="info-section pb-3">
    <v-template class="ma-0 pa-0 secondary--text">{{ title }}</v-template>
    <br />
    <div class="ma-0 pa-0  f-12 " v-bind:class="($vuetify.theme.dark) ? 'textDark' : 'textLight'">
      <span class="ma-0 pa-0  f-12">
        {{ isPreview ? text.substring(0, maxLength) : text }}
      </span>
      <a 
        v-if="isPreview && text.length > maxLength" 
        class="f-11 f-bold" 
        @click="$emit('view-more')"
        v-bind:class="($vuetify.theme.dark) ? 'anchorDark' : 'anchorlight'"
      > View More</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoSection',
  props: {
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      default: ''
    },
    isPreview: {
      type: Boolean,
      default: true
    },
    maxLength: {
      type: Number,
      default: 100
    }
  }
}
</script>
